import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DadosFuncionarioModule } from './../common/dados-funcionario/dados-funcionario.module';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxCurrencyModule } from 'ngx-currency';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { ComboBeneficiarioModule } from '../common/combo-beneficiario/combo-beneficiario.module';
import { ComboFuncionarioModule } from '../common/combo-funcionario/combo-funcionario.module';
import { ComboMetaAcaoModule } from '../common/combo-meta-acao/combo-meta-acao.module';
import { ComboMetaObjetivoModule } from '../common/combo-meta-objetivo/combo-meta-objetivo.module';
import { ComboObjetivoModule } from '../common/combo-objetivo/combo-objetivo.module';
import { ComboPercursoModule } from '../common/combo-percurso/combo-percurso.module';
import { ComboPublicoAlvoModule } from '../common/combo-publico-alvo/combo-publico-alvo.module';
import { OficinaModule } from '../oficina/oficina.module';
import { CopiarDadosOficinaComponent, CopiarDadosOficinaDialogComponent } from '../popup/copiar-dados-oficina/copiar-dados-oficina.component';
import { CadastrarTurmasComponent } from './cadastrar-turmas/cadastrar-turmas.component';
import { CadastrarColaboradoresTurmaComponent } from './colaboradores-turma/cadastrar-colaboradores-turma/cadastrar-colaboradores-turma.component';
import { ColaboradoresTurmaComponent } from './colaboradores-turma/colaboradores-turma.component';
import { ListarColaboradoresTurmaComponent } from './colaboradores-turma/listar-colaboradores-turma/listar-colaboradores-turma.component';
import { DadosTurmaComponent } from './dados-turma/dados-turma.component';
import { AcoesOficinaTurmaComponent } from './oficina/acoes-oficina-turma/acoes-oficina-turma.component';
import { CadastrarAcoesOficinaTurmaComponent } from './oficina/acoes-oficina-turma/cadastrar-acoes-turma/cadastrar-acoes-oficina-turma.component';
import { ListarAcoesOficinaTurmaComponent } from './oficina/acoes-oficina-turma/listar-acoes-turma/listar-acoes-oficina-turma.component';
import { CadastrarOficinasComponent } from './oficina/cadastrar-oficinas/cadastrar-oficinas.component';
import { CadastrarColaboradoresAtividadeComponent } from './oficina/colaboradores-atividade/cadastrar-colaboradores-atividade/cadastrar-colaboradores-atividade.component';
import { ColaboradoresAtividadeComponent } from './oficina/colaboradores-atividade/colaboradores-atividade.component';
import { ListarColaboradoresAtividadeComponent } from './oficina/colaboradores-atividade/listar-colaboradores-atividade/listar-colaboradores-atividade.component';
import { DadosAtividadeComponent } from './oficina/dados-atividade/dados-atividade.component';
import { FormularioAcoesExecutadaMetasTurmaComponent } from './oficina/formulario-acoes-executada-metas-turma/formulario-acoes-executada-metas-turma.component';
import { FormularioAcoesExecutadasColaboradorTurmaComponent } from './oficina/formulario-acoes-executadas-colaborador-turma/formulario-acoes-executadas-colaborador-turma.component';
import { FormularioAcoesExecutadasFrequenciaTurmaComponent } from './oficina/formulario-acoes-executadas-frequencia-turma/formulario-acoes-executadas-frequencia-turma.component';
import { FormularioAcoesExecutadasTurmaComponent } from './oficina/formulario-acoes-executadas-turma/formulario-acoes-executadas-turma.component';
import { FormularioAcoesMetasTurmaComponent } from './oficina/formulario-acoes-metas-turma/formulario-acoes-metas-turma.component';
import { FormularioObjetivoAtividadeTurmaComponent } from './oficina/formulario-objetivo-atividade-turma/formulario-objetivo-atividade-turma.component';
import { ListarOficinasComponent } from './oficina/listar-oficinas/listar-oficinas.component';
import { CadastrarMateriaisComponent } from './oficina/materiais-oficina/cadastrar-materiais/cadastrar-materiais.component';
import { ListarMateriaisComponent } from './oficina/materiais-oficina/listar-materiais/listar-materiais.component';
import { MateriaisOficinaComponent } from './oficina/materiais-oficina/materiais-oficina.component';
import { OficinaComponent } from './oficina/oficina.component';
import { CadastrarPublicoAlvoAtividadeComponent } from './oficina/publico-alvo-atividade/cadastrar-publico-alvo-atividade/cadastrar-publico-alvo-atividade.component';
import { ListarPublicosAlvoAtividadeComponent } from './oficina/publico-alvo-atividade/listar-publicos-alvos-atividades/listar-publico-alvo-atividade.component';
import { PublicoAlvoAtividadeComponent } from './oficina/publico-alvo-atividade/publico-alvo-atividade.component';
import { TurmasRoutingModule } from './turmas-routing.module';
import { TurmasComponent } from './turmas.component';
@NgModule({
  declarations: [TurmasComponent,
                 CadastrarTurmasComponent,
                 DadosTurmaComponent,
                 ColaboradoresTurmaComponent,
                 CadastrarColaboradoresTurmaComponent,
                 ListarColaboradoresTurmaComponent,
                 CadastrarOficinasComponent,
                 ListarOficinasComponent,
                 DadosAtividadeComponent,
                 ColaboradoresAtividadeComponent,
                 CadastrarColaboradoresAtividadeComponent,
                 ListarColaboradoresAtividadeComponent,
                 MateriaisOficinaComponent,
                 CadastrarMateriaisComponent,
                 ListarMateriaisComponent,
                 CopiarDadosOficinaComponent,
                 CopiarDadosOficinaDialogComponent,
                 OficinaComponent,
                 FormularioAcoesExecutadasFrequenciaTurmaComponent,
                 FormularioAcoesExecutadaMetasTurmaComponent,
                 FormularioAcoesMetasTurmaComponent,
                 FormularioAcoesExecutadasColaboradorTurmaComponent,
                 FormularioAcoesExecutadasTurmaComponent,
                 FormularioObjetivoAtividadeTurmaComponent,
                 CadastrarAcoesOficinaTurmaComponent,
                 ListarAcoesOficinaTurmaComponent,
                 AcoesOficinaTurmaComponent,
                 PublicoAlvoAtividadeComponent,
                 CadastrarPublicoAlvoAtividadeComponent,
                 ListarPublicosAlvoAtividadeComponent,
                ],
  imports: [
    ComboPercursoModule,
    CommonModule,
    TurmasRoutingModule,
    MaterialCommonModule,
    DadosFuncionarioModule,
    MatExpansionModule,
    MatTabsModule,
    NgxCurrencyModule,
    OficinaModule,
    ComboBeneficiarioModule,
    ComboMetaAcaoModule,
    ComboFuncionarioModule,
    ComboMetaObjetivoModule,
    ComboObjetivoModule,
    ComboPublicoAlvoModule
  ],
  exports: [
    CopiarDadosOficinaDialogComponent
  ]
})
export class TurmasModule { }
